// apps/web/src/components/ui/Logo.tsx
import { Link } from '@tanstack/react-router'

interface LogoProps {
  /** When true, renders an <a> tag for external/anchor usage (e.g. landing page navbar).
   *  When false or omitted, renders a TanStack Router <Link> to "/". */
  external?: boolean
  fontSize?: number | string
  href?: string
}

export function Logo({ external, fontSize, href }: LogoProps) {
  const style: React.CSSProperties = {
    color: 'var(--lime)',
    fontFamily: 'Clash Display',
    fontSize: fontSize ?? '1.4rem',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
  }

  const content = (
    <>
      Turf
      <span style={{ color: 'var(--text)' }}>Chale.com</span>
    </>
  )

  if (external) {
    return (
      <a href={href ?? '/'} style={style}>
        {content}
      </a>
    )
  }

  return (
    <Link style={style} to="/">
      {content}
    </Link>
  )
}
